"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformToLowercase = void 0;
var class_transformer_1 = require("class-transformer");
function TransformToLowercase(options) {
    return (0, class_transformer_1.Transform)(function (_a) {
        var value = _a.value;
        return (value && typeof value === 'string' ? value.toLowerCase() : value);
    }, options);
}
exports.TransformToLowercase = TransformToLowercase;
//# sourceMappingURL=transform-to-lowercase.js.map